import { render, staticRenderFns } from "./addressMenu.vue?vue&type=template&id=6f063ff5&scoped=true"
import script from "./addressMenu.vue?vue&type=script&lang=js"
export * from "./addressMenu.vue?vue&type=script&lang=js"
import style0 from "./addressMenu.vue?vue&type=style&index=0&id=6f063ff5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f063ff5",
  null
  
)

export default component.exports